import React, { useState } from 'react'
import DashboardLayout from '../../../../../layoutcontainers/DashboardLayout'
import { AppBar, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, List, ListItem, ListItemIcon, ListItemText, Toolbar } from '@mui/material'
import MaterialTypography from '../../../../../components/MaterialTypography'
import MaterialButton from '../../../../../components/MaterialButton'
import { Grid } from '@mui/system'
import MaterialBox from '../../../../../components/MaterialBox'
import MaterialSelect from '../../../../../components/MaterialSelect'
import MaterialInput from '../../../../../components/MaterialInput'
import FolderIcon from "@mui/icons-material/Folder";
import './createTestRun.css'


const project = [
    {
        value: 'Project 1',
        label: 'Project 1',
    },
    {
        value: 'Project 2',
        label: 'Project 2',
    },
    {
        value: 'Project 3',
        label: 'Project 3',
    },
]

const testRunList = [
    {
        value: 'Test Run 1',
        label: 'Test Run 1',
    },
    {
        value: 'Test Run 2',
        label: 'Test Run 2',
    },
    {
        value: 'Test Run 3',
        label: 'Test Run 3',
    },
]

const testPlanList = [
    {
        value: 'Test Plan 1',
        label: 'Test Plan 1',
    },
    {
        value: 'Test Plan 2',
        label: 'Test Plan 2',
    },
    {
        value: 'Test Plan 3',
        label: 'Test Plan 3',
    },
]

const assignList = [
    {
        value: 'Assign 1',
        label: 'Assign 1',
    },
    {
        value: 'Assign 2',
        label: 'Assign 2',
    },
    {
        value: 'Assign 3',
        label: 'Assign 3',
    },
]

const stateList = [
    {
        value: 'New',
        label: 'New',
    },
    {
        value: 'In Progress',
        label: 'In Progress',
    },
    {
        value: 'Under Review',
        label: 'Under Review',
    },
    {
        value: 'Rejected',
        label: 'Rejected'
    },
    {
        value: 'Done',
        label: 'Done'
    }
]

const data = [
    {
        id: 1,
        name: "Folder 1",
        items: [
            { id: "tc-101", name: "Login Test Case" },
            { id: "tc-102", name: "Signup Test Case" },
        ],
    },
    {
        id: 2,
        name: "Folder 2",
        items: [
            { id: "tc-201", name: "Payment Flow Test Case" },
            { id: "tc-202", name: "Logout Test Case" },
        ],
    },
];

const CreateTestRun = () => {
    const [testRun, setTestRun] = useState({
        project: '',
        testRunName: '',
        testCases: '',
        testPlan: '',
        description: '',
        assignRun: '',
        state: ''
    });
    const [open, setOpen] = useState(false);
    const [selectedLeftIds, setSelectedLeftIds] = useState([]);
    const [selectedRightIds, setSelectedRightIds] = useState([]);

    //  Left side: Modules
    const leftList = [
        { id: 1, label: "Login Module" },
        { id: 2, label: "API Module" },
        { id: 3, label: "UI Module" },
        { id: 4, label: "Performance Module" },
    ];

    //  Right side data (test cases mapped by module)
    const rightData = {
        1: [
            { id: "r1", name: "Login with valid credentials" },
            { id: "r2", name: "Login with invalid credentials" },
        ],
        2: [
            { id: "r3", name: "POST /users API" },
            { id: "r4", name: "GET /profile API" },
        ],
        3: [
            { id: "r5", name: "Header alignment check" },
            { id: "r6", name: "Color consistency validation" },
        ],
        4: [
            { id: "r7", name: "Dashboard load test" },
            { id: "r8", name: "Authentication stress test" },
        ],
    };

    // ✅ Filter right-side list based on selected left-side modules
    const filteredRightList = selectedLeftIds.length
        ? selectedLeftIds.flatMap((id) => rightData[id] || [])
        : [];

    // ✅ Toggle left checkbox
    const handleLeftCheck = (id) => {
        setSelectedLeftIds((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );

        // If left checkbox is unchecked → remove its related right-side selections
        if (selectedLeftIds.includes(id)) {
            const relatedIds = (rightData[id] || []).map((r) => r.id);
            setSelectedRightIds((prev) => prev.filter((rId) => !relatedIds.includes(rId)));
        }
    };

    // ✅ Toggle right checkbox
    const handleRightCheck = (id) => {
        setSelectedRightIds((prev) =>
            prev.includes(id) ? prev.filter((rId) => rId !== id) : [...prev, id]
        );
    };

    const handleProjectChange = (selectedProject) => {
        setTestRun({
            ...testRun,
            project: selectedProject
        })
    };

    const handleTestRunChange = () => {

    };

    const handleTestPlanChange = (selectedTestPlan) => {
        setTestRun({
            ...testRun,
            testPlan: selectedTestPlan
        })
    };

    const handleAssignChange = (selectedAssign) => {
        setTestRun({
            ...testRun,
            assignRun: selectedAssign
        })
    };

    const handleStateChange = (selectedState) => {
        setTestRun({
            ...testRun,
            state: selectedState
        })
    };

    const handleAddClick = () => {
        setOpen(true);
    };

    const handleSubmitTestCase = () => {
        console.log("Selected Module IDs:", selectedRightIds);
        setOpen(false);
        setSelectedLeftIds([]);
        setSelectedRightIds([]);
    };

    const handleCancelTestCase = () => {
        setOpen(false);
        setSelectedLeftIds([]);
        setSelectedRightIds([]);
    };


    return (
        <DashboardLayout>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="sticky"
                    sx={{
                        backgroundColor: "#D7DEED",
                        borderRadius: '8px'
                    }}>
                    <Toolbar>
                        <MaterialTypography
                            variant="h5"
                            noWrap
                            fontWeight="bold"
                            color='dark'
                            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
                        >
                            Create Test Run
                        </MaterialTypography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                            <MaterialButton variant="outlined" color='dark' size="small">Cancel</MaterialButton>
                            <MaterialButton variant='contained' color='dark' size='small'>Submit</MaterialButton>
                        </Box>
                    </Toolbar>
                </AppBar>
            </Box>
            <Box sx={{ padding: 2, mt: 2, backgroundColor: '#fff', borderRadius: '8px' }}>
                <Grid container spacing={2} direction='row'>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <MaterialTypography variant='caption' color='secondary'>Project Name<span style={{ color: 'red' }}>*</span></MaterialTypography>
                            <MaterialSelect
                                label='Project Name'
                                size='small'
                                value={testRun.project}
                                options={project.map((p) => ({ label: p.label, value: p.value }))}
                                onChange={handleProjectChange}
                            />
                        </MaterialBox>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <MaterialTypography variant='caption' color='secondary'>Test Run Name<span style={{ color: 'red' }}>*</span></MaterialTypography>
                            <MaterialInput
                                label='Test run Name'
                                size='small'
                                value={testRun.testRunName}
                                onChange={handleTestRunChange}
                            />
                        </MaterialBox>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <MaterialTypography variant='caption' color='secondary'>Test Cases<span style={{ color: 'red' }}>*</span></MaterialTypography>
                            <Grid container direction='row' spacing={1}>
                                <Grid size={{ xs: 9.5 }}>
                                    <MaterialInput
                                        label='Test Cases'
                                        size='small'
                                        value={testRun.testCases}
                                    />
                                </Grid>
                                <Grid size={{ xs: 2 }}>
                                    <MaterialButton variant='contained' color='dark' size='small' onClick={handleAddClick}>Add</MaterialButton>
                                </Grid>
                            </Grid>
                        </MaterialBox>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <MaterialTypography variant='caption' color='secondary'>Test Plans<span style={{ color: 'red' }}>*</span></MaterialTypography>
                            <MaterialSelect
                                label='Test Plans'
                                size='small'
                                value={testRun.testPlan}
                                options={testPlanList.map((test) => ({ label: test.label, value: test.value }))}
                                onChange={handleTestPlanChange}
                            />
                        </MaterialBox>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <MaterialTypography variant='caption' color='secondary'>Assign Run</MaterialTypography>
                            <MaterialSelect
                                label='Assign Run'
                                size='small'
                                value={testRun.assignRun}
                                options={assignList.map((test) => ({ label: test.label, value: test.value }))}
                                onChange={handleAssignChange}
                            />
                        </MaterialBox>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <MaterialTypography variant='caption' color='secondary'>State</MaterialTypography>
                            <MaterialSelect
                                label='Status'
                                size='small'
                                value={testRun.state}
                                options={stateList.map((test) => ({ label: test.label, value: test.value }))}
                                onChange={handleStateChange}
                            />
                        </MaterialBox>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <MaterialTypography variant='caption' color='secondary'>Description</MaterialTypography>
                            <MaterialInput
                                label='Description'
                                placeholder='Write in brief about this test run'
                                size='small'
                                multiline
                                rows={4}
                                value={testRun.description}
                            />
                        </MaterialBox>
                    </Grid>
                </Grid>
            </Box>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Select Test Cases</DialogTitle>

                <DialogContent className="dialog-content">
                    {/* LEFT SIDE */}
                    <div className="dialog-left">
                        <List dense>
                            {leftList.map((item) => (
                                <ListItem key={item.id} disablePadding>
                                    <Checkbox
                                        checked={selectedLeftIds.includes(item.id)}
                                        onChange={() => handleLeftCheck(item.id)}
                                        size="small"
                                    />
                                    <ListItemText primary={item.label} />
                                </ListItem>
                            ))}
                        </List>
                    </div>

                    {/* RIGHT SIDE */}
                    <div className="dialog-right">
                        <List dense>
                            {filteredRightList.length > 0 ? (
                                filteredRightList.map((item) => (
                                    <ListItem key={item.id} disablePadding>
                                        <Checkbox
                                            checked={selectedRightIds.includes(item.id)}
                                            onChange={() => handleRightCheck(item.id)}
                                            size="small"
                                        />
                                        <ListItemText primary={item.name} />
                                    </ListItem>
                                ))
                            ) : (
                                <ListItem>
                                    <ListItemText primary="No test cases available" />
                                </ListItem>
                            )}
                        </List>
                    </div>
                </DialogContent>

                <DialogActions>
                    <MaterialButton onClick={handleCancelTestCase} variant="outlined" color="dark" size='small'>
                        Cancel
                    </MaterialButton>
                    <MaterialButton onClick={handleSubmitTestCase} variant="contained" color="dark" size='small'>
                        Submit
                    </MaterialButton>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    )
}

export default CreateTestRun
